import React, { PureComponent } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Element } from 'react-scroll'
import DossierHeaderPage from '../../../containers/dossiers/commons/dossierHeaderPage'
import ButtonsHeader from '../../dossiers/common/ButtonsHeader'
import ButtonsSidebar from '../../dossiers/common/ButtonsSidebar'
import SalesComponent from '../../dossiers/registrationDelivery/SalesComponent'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import { compareObjects } from '../../../util/utils'
import { getComponentsPermisions } from '../../../util/permisionFunctions'
import { buttonsHeader } from '../../../constants/dossier/common/buttonsHeader'
import { buttonsSidebar } from '../../../constants/dossier/common/buttonsSidebar'
import { permissions } from '../../../constants/backendIds'
import Client from '../../dossiers/common/Client'
import Vehicle from '../../dossiers/common/Vehicle'
import DocumentaryManagementPage from '../../../containers/dossiers/commons/DocumentaryManagementPage'
import RejectCommentModal from '../../../components/dossiers/common/RejectCommentModal'
import UAC from '../../dossiers/common/uac/UAC'
import PaperworkTablePage from '../../../containers/dossiers/commons/PaperworkComponentPage'
import Delivery from '../../../components/dossiers/common/Delivery'
import { reduxForm } from 'redux-form'
import AuditInfo from '../../dossiers/common/audit/AuditInfo'
import TrackingContainer from '../../../containers/tracking/trackingContainer'
import { TrackedPages } from '../../../constants/tracking/TrackedPages'
import Charges from '../../../components/dossiers/common/Charges'
import DossierSummary from '../../dossiers/common/DossierSummary'
import RelatedDossiers from '../../dossiers/common/RelatedDossiers'
import CommentComponent from '../../dossiers/common/comment/CommentComponent'

class RegistrationDeliveryHistorical extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      modalOpen: true,
      isVehicleLoaded: false,
      isDeliveryLoaded: false,
      isFinanceLoaded: false,
      isClientLoaded: false,
      showRejectCommentModal: false,
      accessoriesOpen: false,
      optionalsOpen: false,
      noRecoverableCostsOpen: false,
      discountsOpen: false,
      servicesOpen: false,
      activeTabConfiguration: null,
      headerTabConfiguration: null,
      isOtherDataLoaded: false,
      isEconomicLoaded: false,
      componentsConfiguration: {
        bsale: null,
        entity: null,
        vehicle: null,
        campaign: null,
        uac: null,
        finance: null,
        paperwork: null,
        charge: null,
        other_data: null,
        delivery: null
      }
    }
    this.goBack = this.goBack.bind(this)
  }

  goBack () {
    this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
    this.props.history.goBack()
  }

  toggleRejectCommentModal (showRejectCommentModal) {
    this.setState({ showRejectCommentModal })
  }

  onClickRelatedDossierColumn (columnCode) {
    let columnCodeOrder = '+' + columnCode
    if (columnCodeOrder === this.props.relatedDossiersOrderBy) {
      columnCodeOrder = '-' + columnCode
    }
    this.props.actions.fetchFilteredRelatedDossier(this.props.dossier.dossierId, columnCodeOrder, true)
  }

  getRelatedDossierColumnIcon (columnCode) {
    if ('+' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-asc'
    } else if ('-' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  submitRegistrationDeliveryDossier (values) {
    this.props.actions.saveRegistrationDeliveryDossier(values)
  }

  fetchRegistrationDeliveryDossierPromise (dossierId) {
    return new Promise((resolve, reject) => {
      return this.props.actions.fetchRegistrationDeliveryDossier(dossierId, resolve, reject, true)
    })
  }

  initializePermisions (props) {
    const componentKeys = Object.keys(this.state.componentsConfiguration)
    const newState = getComponentsPermisions(props.dossier.viewConfiguration.tabsConfiguration, props.activeTab, componentKeys)
    this.setState({ ...this.state, ...newState })
  }

  componentDidMount () {
    this.props.actions.fetchCommercialSocietyTypeCombo()
    this.props.actions.restartRegistrationDeliveryState()
    this.fetchRegistrationDeliveryDossierPromise(this.props.match.params.dossierId).then(() => {
      const form = {
        ...this.props.dossier,
        entityComponent: this.props.dossier.entityComponent.entityId ? this.props.dossier.entityComponent : undefined
      }
      this.props.initialize(form)
      this.initializePermisions(this.props)
      this.props.actions.fetchRegistrationDeliveryDossierDependants(this.props.match.params.dossierId, true)
      this.props.actions.fetchCustomFields(this.props.dossier.dossierSubTypeId)
      this.props.actions.registerLastAccess(this.props.match.params.dossierId, true)
      this.props.trackVisitPage({
        documentTitle: TrackedPages.REGISTRATION_DELIVERY_HISTORICAL,
        organizedUnitId: this.props.dossier.organizedUnitId,
        href: window.location.href
      })
    })
  }

  componentDidUpdate (prevProps) {
    if ((this.props.showManagementModal && !prevProps.showManagementModal) || this.props.match.params.dossierId !== prevProps.match.params.dossierId) {
      if (this.props.match.params.dossierId !== prevProps.match.params.dossierId) {
        this.props.actions.restartRegistrationDeliveryState()
        this.props.actions.setScrollTo(buttonsSidebar.bsale)
        this.props.actions.setActiveSection(buttonsSidebar.bsale)
        this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
        this.props.actions.closeAddOrEditDocumentModal()
      }
      this.fetchRegistrationDeliveryDossierPromise(this.props.match.params.dossierId).then(() => {
        const form = { ...this.props.dossier }
        if (!this.props.dossier.entityComponent.entityId) delete form.entityComponent
        this.props.initialize(form)
        this.initializePermisions(this.props)
        this.props.actions.fetchRegistrationDeliveryDossierDependants(this.props.match.params.dossierId, true)
      })
    }

    if ((this.props.dossier && this.props.dossier.viewConfiguration && this.props.dossier.viewConfiguration.tabsConfiguration &&
      !compareObjects(prevProps.dossier.viewConfiguration.tabsConfiguration || {}, this.props.dossier.viewConfiguration.tabsConfiguration || {}, true)) ||
      (prevProps.dossier.dossierId && prevProps.activeTab !== this.props.activeTab)) {
      this.initializePermisions(this.props)
    }

    if (this.props.dossier.dossierId && this.props.statusHeaderHeight && this.props.activeSection) {
      switch (this.props.activeSection) {
        case buttonsSidebar.accessory:
          this.setState({ accessoriesOpen: true })
          break
        case buttonsSidebar.optional:
          this.setState({ optionalsOpen: true })
          break
        case buttonsSidebar.no_recover:
          this.setState({ noRecoverableCostsOpen: true })
          break
        case buttonsSidebar.discount:
          this.setState({ discountsOpen: true })
          break
        case buttonsSidebar.service:
          this.setState({ servicesOpen: true })
          break
      }
    }

    const firstCustomFieldsLoad = prevProps.dossier.customFieldsByComponent?.length < this.props.dossier.customFieldsByComponent?.length
    if (firstCustomFieldsLoad) {
      let customFields = {}
      if (this.props.dossier.customFieldsValues) {
        this.props.dossier.customFieldsValues.map(x => {
          customFields[x.key] = x.value
        })
      }
      const form = {
        ...this.props.dossier,
        customFields: customFields,
        entityComponent: this.props.dossier.entityComponent.entityId ? this.props.dossier.entityComponent : undefined
      }
      this.props.initialize(form)
    }
  }

  componentWillUnmount () {
    this.props.actions.setActiveSection(buttonsSidebar.bsale)
    this.props.actions.setScrollTo(null)
    this.props.actions.resetButtonsHeader()
    this.props.actions.closeAddOrEditDocumentModal()
    this.props.actions.restartRegistrationDeliveryState()
  }

  handleToUpdateComponent (component) {
    if (component.isVehicleLoaded === false || buttonsSidebar.vehicle === component) this.setState({ isVehicleLoaded: true })
    if (component.isClientLoaded === false || buttonsSidebar.entity === component) this.setState({ isClientLoaded: true })
    if (component.isFinanceLoaded === false || buttonsSidebar.finance === component) this.setState({ isFinanceLoaded: true })
    if (component.isDeliveryLoaded === false || buttonsSidebar.delivery === component) this.setState({ isDeliveryLoaded: true })
    if (component.isOtherDataLoaded === false || buttonsSidebar.other_data === component) this.setState({ isOtherDataLoaded: true })
    if (component.isEconomicLoaded === false) this.setState({ isEconomicLoaded: true })
    this.props.actions.setScrollTo(component)
  }

  togglePanel () {
    if (this.state.registrationDeliveryOpen) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ registrationDeliveryOpen: !this.state.registrationDeliveryOpen })
  }

  toogleHidedossierBodyLeft () {
    this.setState({ dossierBodyLeftClose: !this.state.dossierBodyLeftClose })
  }

  render () {
    const {
      t, handleSubmit, dossier, combos = {}, change, pristine, vehicleProps, activeTab, buttonsHeaderHeight, activeSection, statusHeaderHeight, windowWidth, documentExport,
      dossier: {
        dossierId, dossierSubTypeId, header, entityChangeable,
        checkListHeader, comments, uac, paperWorks, organizedUnitId, purchasesDossierId,
        dossierCompleteDeliveryCheckListItems, dossierDeliveryCheckListPurchase, showAlertSendPending,
        viewConfiguration, viewConfiguration: { buttonsPermission = [] },
        vehicleComponent: { vehicleId }, dossierRelatedDossiers, auditInfo, order, charges, isPreCancelled
      },
      actions: {
        openDocumentModal,
        updateDependantsSaleDossierAndHeader,
        fetchOperationType,
        postPaymentSignalStatusSuccess,
        openDocumentEditionModal,
        fetchOrder,
        fetchRegistrationDeliveryDossierDependants,
        setActiveTab, setButtonsHeaderHeight, resetButtonsHeader,
        setActiveSection,
        setScrollerOptions,
        /* navigateTo, */
        fetchComboOrigin,
        printDocumentaryChecklist,
        fetchComboDestination,
        refreshAuditInfo,
        fetchAuditDetails,
        fetchAuditDetailsModal,
        updateComment,
        createComment,
        deleteComment,
        markCommentAsRead,
        fetchDocumentsGroupedAuditDetails,
        fetchDocumentsGroupedAuditDetailsModal,
        fetchRegistrationDeliveryDeliveryHistorical,
        fetchRegistrationDeliveryFinancingHistorical,
        fetchRegistrationDeliveryVehicleHistorical,
        fetchRegistrationDeliveryClientHistorical,
        saveSelectedDocuments,
        fetchRegistrationDeliveryEconomic,
        fetchEntityCountryTypeCombo, fetchEntityStateTypeCombo,
        fetchEntityCityTypeCombo, fetchEntityTownTypeCombo,
        fetchEntityColonyTypeCombo, fetchEntityCPTypeCombo, openCommonModal,
        fetchCommercialSocietyTypeCombo,
        fetchActivityBpro,
        fetchClientDataAddress,
        fetchFilteredRelatedDossier
      }
    } = this.props

    if (!dossierId) return null
    const saveSalePermission = buttonsPermission.includes('sale_save')
    const saveRegistrationDeliveryPermission = buttonsPermission.includes('registrationDelivery_save')
    const tKey = 'DOSSIER_COMPONENTS.'
    const panelsPaddingTop = statusHeaderHeight + buttonsHeaderHeight - (statusHeaderHeight + buttonsHeaderHeight - 82) // 82px es el paddingTop definido en el layout.

    return (
      <div className="dossierGrid">
        <div className="dossierGridPart-header">
          <DossierHeaderPage
            headerData={header}
            stages={checkListHeader}
            dossierType={dossierTypesConstant.registrationDelivery}
            headerTabConfiguration={this.state.headerTabConfiguration}
            goBack={this.goBack}
            dossierId={dossier.dossierId}
          />
        </div>
        <div className="dossierGridPart-body">
          <div className={'dossierBody-left ' + (this.state.dossierBodyLeftClose ? 'close' : '') }>

            <DossierSummary
              t = {t}
              dossier={dossier}
              header={header}
              dossierType={dossierTypesConstant.registrationDelivery}
              dossierSubType={dossierSubTypeId}
              brandCombo = {combos.brandCombo}
              entityTypeCombo = {combos.entityTypeCombo}
              dossierRelatedDossiers = {dossierRelatedDossiers}
            >
            </DossierSummary>
          </div>
          <div className='dossierBody-center'>
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.state.dossierBodyLeftClose ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.toogleHidedossierBodyLeft()} className={'closeDossierInfo ' + (this.state.dossierBodyLeftClose ? '' : 'closeInnerMenu')}><i className={this.state.dossierBodyLeftClose ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
          </div>
          <div className='dossierBody-right'>
            <div className="dossierGridPart-sectionsMenu">
              <ButtonsHeader
                t={t}
                pristine={pristine}
                actions={{
                  openDocumentModal: () => openDocumentModal(dossierId, dossierTypesConstant.registrationDelivery, pristine, 1, true),
                  setActiveTab,
                  setButtonsHeaderHeight,
                  resetButtonsHeader,
                  setScrollerOptions
                }}
                dossierId={this.props.match.params.dossierId}
                viewConfiguration={viewConfiguration}
                dossierType={dossierTypesConstant.registrationDelivery}
                activeTab={activeTab}
                marginTop={statusHeaderHeight + buttonsHeaderHeight}
                windowWidth={windowWidth}
                historical={true}
                togglePanel={() => this.togglePanel()}
              />
            </div>
            <div className="dossierGridPart-ComponentSection">
              <Form autoComplete="off" onSubmit={handleSubmit(this.submitRegistrationDeliveryDossier.bind(this))}>
                {
                  activeTab === buttonsHeader.datos_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="_nd dossierGridPart-ComponentSection-Inner" >
                      <div className="ComponentSection-InnerMennu">
                        <ButtonsSidebar
                          t={t}
                          dossierId={dossierId}
                          historical={true}
                          isClientLoaded={this.state.isClientLoaded}
                          isFinanceLoaded={this.state.isFinanceLoaded}
                          isDeliveryLoaded={this.state.isDeliveryLoaded}
                          isVehicleLoaded={this.state.isVehicleLoaded}
                          isOtherDataLoaded={this.state.isOtherDataLoaded}
                          isEconomicLoaded={this.state.isEconomicLoaded}
                          dossierType={dossierTypesConstant.registrationDelivery}
                          dossierSubTypes={dossierSubTypeId}
                          marginTop={statusHeaderHeight + buttonsHeaderHeight}
                          buttonsHeaderHeight={buttonsHeaderHeight}
                          tabConfiguration={this.state.activeTabConfiguration}
                          handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                          actions={{ setActiveSection, fetchRegistrationDeliveryDeliveryHistorical, fetchRegistrationDeliveryFinancingHistorical, fetchRegistrationDeliveryVehicleHistorical, fetchRegistrationDeliveryClientHistorical }}
                          pristine={pristine}
                        />
                      </div>
                      <div className="ComponentSection-InnerData" id="dossierData" >
                        {this.state.componentsConfiguration.bsale && this.state.componentsConfiguration.bsale.permission > permissions.hidden && (
                          <Element style={{ zIndex: 14 }} name={buttonsSidebar.bsale} id="bsale">
                            <SalesComponent
                              t={t}
                              dossier={dossier}
                              salesOpen={activeSection === buttonsSidebar.bsale}
                              combos={combos}
                              actions={{
                                change,
                                fetchOperationType,
                                printDocumentaryChecklist,
                                openDocumentEditionModal,
                                postPaymentSignalStatusSuccess,
                                setActiveTab,
                                setActiveSection
                              }}
                              readOnlyFields={true}
                              dossierType={dossierTypesConstant.registrationDelivery}
                              componentConfiguration={this.state.componentsConfiguration.bsale}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.bsale)?.customFields}
                              isHistorical= {true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.entity && this.state.componentsConfiguration.entity.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.entity}>
                            <Client
                              t={t}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              isClientLoaded={this.state.isClientLoaded}
                              dossier={dossier}
                              pristine={pristine}
                              combos={combos}
                              entityChangeable={entityChangeable}
                              dossierType={dossierTypesConstant.registrationDelivery}
                              actions={{
                                change,
                                openDocumentEditionModal,
                                fetchRegistrationDeliveryClientHistorical,
                                setActiveSection,
                                fetchEntityCountryTypeCombo,
                                fetchEntityStateTypeCombo,
                                fetchEntityCityTypeCombo,
                                fetchEntityTownTypeCombo,
                                fetchEntityColonyTypeCombo,
                                fetchEntityCPTypeCombo,
                                openCommonModal,
                                fetchCommercialSocietyTypeCombo,
                                fetchActivityBpro,
                                fetchClientDataAddress
                              }}
                              readOnlyFields={!saveRegistrationDeliveryPermission}
                              open={activeSection === buttonsSidebar.entity}
                              componentConfiguration={this.state.componentsConfiguration.entity}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.entity)?.customFields}
                              isHistorical= {true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.vehicle && this.state.componentsConfiguration.vehicle.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.vehicle}>
                            <Vehicle
                              parentDossierType={{
                                isPaperwork: false,
                                isSales: false,
                                isPurchase: false,
                                isRegistrationDelivery: true
                              }}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              isVehicleLoaded={this.state.isVehicleLoaded}
                              dossierId={dossierId}
                              t={t}
                              searchedVehicleProps={vehicleProps}
                              orderId={dossier.orderId}
                              order={order}
                              dossierParentId={purchasesDossierId}
                              dossierWithVehicle={!!vehicleId}
                              combos={combos}
                              actions={{
                                fetchOrder,
                                fetchComboOrigin,
                                fetchComboDestination,
                                fetchRegistrationDeliveryVehicleHistorical,
                                setActiveSection
                              }}
                              readOnlyFields={!saveRegistrationDeliveryPermission}
                              open={activeSection === buttonsSidebar.vehicle}
                              dossierType={dossierTypesConstant.registrationDelivery}
                              dossierSubType={dossierSubTypeId}
                              componentConfiguration={this.state.componentsConfiguration.vehicle}
                              // codeVehicleConfiguration={registrationDeliveryConfiguration.showCodecombos}
                              organizedUnitId={dossier.organizedUnitId}
                              comercialCode={this.props.dossier.vehicleComponent.comercialCode}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.vehicle)?.customFields}
                              isHistorical={true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.uac && this.state.componentsConfiguration.uac.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.uac}>
                            <UAC
                              t={t}
                              uac={uac}
                              actions={{ setActiveSection }}
                              readOnlyFields={true}
                              open={activeSection === buttonsSidebar.uac}
                              componentConfiguration={this.state.componentsConfiguration.uac}
                              dossierType = { dossierTypesConstant.registrationDelivery }
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.uac)?.customFields}
                              isHistorical= {true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.paperwork && this.state.componentsConfiguration.paperwork.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.paperwork}>
                            <PaperworkTablePage
                              organizedUnitId={organizedUnitId}
                              dossierParentId={dossierId}
                              updateDossierAction={fetchRegistrationDeliveryDossierDependants}
                              showAlertSendPending={showAlertSendPending}
                              paperwork={paperWorks}
                              dossierType={dossierTypesConstant.registrationDelivery}
                              readOnlyFields={true}
                              isHistorical={true}
                              open={activeSection === buttonsSidebar.paperwork}
                              componentConfiguration={this.state.componentsConfiguration.paperwork}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.paperwork)?.customFields}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.charge && this.state.componentsConfiguration.charge.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.charge}>
                            <Charges
                              t={t}
                              dossier={dossier}
                              charges={charges}
                              actions={{
                                openDocumentEditionModal,
                                updateDependantsSaleDossierAndHeader,
                                fetchSalesEconomic: fetchRegistrationDeliveryEconomic,
                                setActiveSection
                              }}
                              dossierType={dossierTypesConstant.registrationDelivery}
                              readOnlyFields={true}
                              isPreCancelled={isPreCancelled}
                              open={activeSection === buttonsSidebar.charge}
                              componentConfiguration={this.state.componentsConfiguration.charge}
                              dossierId={dossierId}
                              pristine={pristine}
                              historical={true}
                              isEconomicLoaded={this.state.isEconomicLoaded}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.charge)?.customFields}
                              isHistorical= {true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.delivery && this.state.componentsConfiguration.delivery.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.delivery}>
                            <Delivery
                              t={t}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              isDeliveryLoaded={this.state.isDeliveryLoaded}
                              actions={{
                                fetchRegistrationDeliveryDeliveryHistorical,
                                setActiveSection
                              }}
                              dossierId={dossierId}
                              pristine={pristine}
                              isRegistrationDeliveryDossier={true}
                              dossierCompleteDeliveryCheckListItems={dossierCompleteDeliveryCheckListItems}
                              dossierDeliveryCheckListPurchase={dossierDeliveryCheckListPurchase}
                              readOnlyFields={true}
                              open={activeSection === buttonsSidebar.delivery}
                              dossierSubTypeId={dossierSubTypeId}
                              componentConfiguration={this.state.componentsConfiguration.delivery}
                              combos={combos}
                              customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.delivery)?.customFields}
                              isHistorical= {true}
                              historical={true}
                            />
                          </Element>
                        )}
                      </div>
                    </div>
                  )
                }
                {
                  activeTab === buttonsHeader.gestor_documental && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner sales-panel gestorDocumental">
                      <div className="ComponentSection-InnerData">
                        <DocumentaryManagementPage
                          dossier={dossier}
                          dossierType={dossierTypesConstant.registrationDelivery}
                          saveSelectedDocuments={saveSelectedDocuments}
                          documentExport={documentExport}
                          combos={combos}
                          isHistorical={true}
                          tabConfiguration={this.state.activeTabConfiguration}
                          configuration={this.state.activeTabConfiguration}
                          downloadButtonPermission={this.state.activeTabConfiguration.componentsConfiguration.downloadDocumentsButton}
                          historical={true}
                        />
                      </div>
                    </div>
                  )}
                {
                  activeTab === buttonsHeader.expedientes_relacionados && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner related-dossiers-table">
                      <div className="ComponentSection-InnerData">
                        <RelatedDossiers
                          t={t}
                          relatedDossiersOrderBy = {this.props.relatedDossiersOrderBy}
                          panelsPaddingTop = {panelsPaddingTop}
                          history = {this.props.history}
                          dossierRelatedDossiers = {dossierRelatedDossiers}
                          dossierId= {dossierId}
                          isHistorical= {true}
                          actions={{ fetchFilteredRelatedDossier }}
                        />
                      </div>
                    </div>
                  )}
                {
                  activeTab === buttonsHeader.actividad_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner auditInfo">
                      <div sm={12} className="ComponentSection-InnerData">
                        <AuditInfo
                          auditInfo={auditInfo}
                          dossierType={dossierTypesConstant.registrationDelivery}
                          actions={{ refreshAuditInfo, fetchAuditDetails, fetchAuditDetailsModal, fetchDocumentsGroupedAuditDetails, fetchDocumentsGroupedAuditDetailsModal }}
                          dossier={dossier}
                          historical={true}
                          isHistorical= {true}
                          t={t}
                        />
                      </div>
                    </div>
                  )
                }
                {
                  activeTab === buttonsHeader.observaciones && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner commentComponent">
                      <div className="ComponentSection-InnerData">
                        <CommentComponent
                          comments={comments}
                          actions={{ updateComment, createComment, deleteComment, markCommentAsRead }}
                          readOnlyFields={!saveSalePermission}
                          dossierType="registrationDeliveryDossier"
                          t={t}
                          tKey={tKey}
                          combos={{ allReasonCombo: this.props.combos.allReasonCombo }}
                          openComponent={activeTab === buttonsHeader.observaciones}
                          dossierId={this.props.dossier.dossierId}
                          historical={true}
                          isHistorical= {true}
                        />

                      </div>
                    </div>
                  )}
              </Form>
            </div>
          </div>
        </div>
        {this.state.showRejectCommentModal && <RejectCommentModal
          t={t}
          showModal={this.state.showRejectCommentModal}
          actions={{
            closeModal: () => this.toggleRejectCommentModal(false)
          }}
        />}

      </div>
    )
  }
}

var decoratedComponent = TrackingContainer(RegistrationDeliveryHistorical, false)

export default reduxForm({
  form: 'registrationDeliveryDossier'
})(decoratedComponent)
